<template>
  <div class="main">
    <ball></ball>
    <div class="nav">
        <van-nav-bar
        title="确认挂号"
        left-arrow
        left-text="返回"
        @click-left="onClickLeft"
      />
    </div>
    <div class="body">
      <div class="head">
        <div class="datails_item_head">
          <div class="datails_item_title">就诊人:{{name}}</div>
        
        </div>
        <div class="icon_btn" @click="$router.push('/patient_card_selectuser_querydept')">
          <van-image
            fit="contain"
            :src="require('../../assets/img/switch.png')"
            height="27px"
            width="35px"
          ></van-image>
          <div class="datails_item_head_text">选择</div>
        </div>
      </div>
      <!-- <div class="datails_item">
        <div class="datails_item_title">门诊号</div>
        <div class="datails_item_text">1001</div>
      </div> -->
       <div class="datails_item">
        <div class="datails_item_title">预约医院</div>
        <div class="datails_item_text">{{hospname}}</div>
      </div>
       <div class="datails_item">
        <div class="datails_item_title">预约科室</div>
        <div class="datails_item_text">{{deptName}}</div>
      </div>
       <div class="datails_item" v-if="register_level_falg">
        <div class="datails_item_title">门诊类型</div>
        <div class="datails_item_text">{{regLevelName}}</div>
      </div>
      <div class="datails_item">
        <div class="datails_item_title">挂号费</div>
        <div class="datails_item_text">￥: {{regFee}}</div>
      </div>
      <div class="datails_item"  @click="show = true">
          <div class="datails_item_title">挂号日期</div>
        <div class="datails_item_text">{{date}}</div>
      <!-- <van-cell title="选择单个日期"  :show-confirm="false" /> -->
      </div>
       <div class="datails_item"  v-if="poptimelist&&poptimelist.length>0"  @click="showTime = true">
          <div class="datails_item_title">挂号时段</div>
        <div class="datails_item_text">{{showpoptime}}</div> 
      <!-- <van-cell title="选择单个日期"  :show-confirm="false" /> -->
      </div>
      <div v-if="paywaylist.length > 1">
        <div class="datails_item">
          <div class="datails_item_title">支付方式</div>
        </div>
        <div>
          <div
            class="pay_item"
            v-for="(item, index) in paywaylist"
            :key="index"
          >
            <div class="datails_item_title">{{ item.payvalue }}</div>
            <van-radio-group v-model="radio" direction="horizontal">
              <van-radio :name="item.paykey">
                <van-image
                  class="head_img"
                  width="50"
                  height="25"
                  :src="require(`@/assets/${item.url}.png`)"
                />
              </van-radio>
            </van-radio-group>
          </div>
        </div>
      </div>
         <van-popup v-model="showTime" round position="bottom" :style="{ height: '50%'  }">
              <div class="poptime" >
                <van-button v-for="(item,index) in poptimelist" :key="index"
                small
               v-if="
               new Date(isdate+ ' '  +item.endTime).getTime()-600000
            >new Date().getTime() "
                class="popbtn"
                @click="getPoptime(item)">
                {{item.startTime}}~{{item.endTime}}
                </van-button>
              </div>
    </van-popup>
       <van-calendar color="#5B8DF6" :min-date="minDate" :max-date="maxDate" v-model="show" @confirm="onConfirm" />
     
    </div>
    <div class="foot">
            <div class="details_BTn"> 
              <div class="btn">
                <van-button type="info" size="large" round :disabled="btnflag"  @click="schedulhead_d()">确认挂号</van-button>
            </div>
            </div>
    </div>
    </div>
 
</template>

<script>
import Nav from "../../components/nav.vue";
import { Dialog } from "vant";
export default {
  data() {
    return {
      popstarttime: "",
      popendtime: "",
      showpoptime: "点击选择",
      popbtnflag: true,
      selectPoptime: null,
      poptimelist: [],
      btntime: "点击选择",
      showTime: false,
      //路由地址
      path: "",
      //挂号级别flag
      register_level_falg: false,
      //版本控制Flag
      vtypeflag: true,
      //支付订单
      paywaylist: null,
      //日期控件
      date: "点击选择",
      show: false,
      minDate: new Date(),
      maxDate: new Date(),
      //
      //展示的时间
      show_date: "",
      //医院名
      hospname: "",
      out_trade_no: "",
      //控制开关
      btnflag: false,
      //wx支付需要参数
      appId: "",
      timeStamp: "",
      nonceStr: "",
      pacKage: "",
      signType: "",
      paySign: "",
      //
      radio: "wechat",
      //科室id
      deptId: "",
      //挂号级别id
      regLevelId: "",
      //就诊卡号
      clientId: "",
      //就诊人姓名
      name: "",
      //科室名
      deptName: "",
      //挂号费
      regFee: null,
      //挂号类型名
      regLevelName: "",
      //   //时间名
      //   noonName: "",
      //   // 看诊时间
      //   seeDate: "",

      //挂号类型id
      //   regTypeId: "",
      //锁号类型id
      //   schedulId: "",
      //医院Id
      //   docId: "",
      //医生
      //   doctorId:"",
      version: "",
      localdeptid: "",
      payWay: "",
      out_trade_no:"",
      tips:""
    };
  },
  components: {
    Nav,
  },
  beforeRouteEnter(to, from, next) {
    // console.log(from.path);

    next((vm) => {
      // this.path= from.path
      vm.path = from.path;
      // console.log(vm.path);
    });
  },
  mounted() {
    
    if (this.$route.query.deptid) {
      this.localdeptid = this.$route.query.deptid;
      this.$local.set("localdeptid", this.localdeptid);
    }
    if (this.date == "点击选择") {
      this.isdate =
        new Date().getFullYear() +
        "/" +
        (new Date().getMonth() + 1) +
        "/" +
        new Date().getDate();
    }
    // this.getghInfo()
    this.getDetailsInfo();
    this.getDateWeek();
    this.getTimes();
    this.getTips();
  },

  methods: {
       onClickLeft() {
      this.$router.push("/index");
    },
    //获取按钮事件
    getPoptime(item) {
      this.popstarttime = item.startTime;
      this.popendtime = item.endTime;
      this.showpoptime = this.popstarttime + "~" + this.popendtime;
      this.$local.set("popstarttime", this.popstarttime);
      this.$local.set("popendtime", this.popendtime);
      this.$local.set("showpoptime", this.showpoptime);
      this.showTime = false;
    },
    //
    //日期控件
    formatDate(date) {
      // console.log("date",date);
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    },
    onConfirm(date) {
      this.show = false;
      //   console.log(this.show)
      this.date = this.formatDate(date);
      this.$local.set("date", this.date);
      this.isdate = this.date;
    },
    //
    //获取时间
    async getDateWeek() {
      try {
        this.$showLoad();
        let url = "/hospitalconf/getDateWeek";
        await this.$axios_request.request_data(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            this.minDate = new Date(data.data[0].date_text);
            this.maxDate = new Date(data.data[data.data.length - 1].date_text);
            // this.dateList = data.data;
            this.$hideLoad();
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
        this.isLoad = true;
      }
    },
    //
    onBridgeReady(appId, timeStamp, nonceStr, pacKage, signType, paySign) {
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: appId, //公众号名称，由商户传入
          timeStamp: timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: nonceStr, //随机串
          package: pacKage,
          signType: signType, //微信签名方式：
          paySign: paySign, //微信签名
        },
        async (res) => {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            // this.$hideLoad();
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            // this.$toast.success("支付成功");
            if(this.hospname=="彝良县中医医院"){
              this.$router.push({
                    path: "/reghistory_ymzyy",
                    query: {
                      clientId: this.clientId,
                      name: this.name,
                    },
                  });
                  return
            }
                Dialog.alert({
                  title: "挂号成功",
                  message:
                    "到医院就诊时请带本院就诊卡，如无就诊卡请提前时间到导医台办理本院就诊卡，否则无法打印报告单",
                }).then(() => {
                  this.$router.push({
                    path: "/reghistory_ymzyy",
                    query: {
                      clientId: this.clientId,
                      name: this.name,
                    },
                  });
                });
          }
        }
      );
    },
    async schedulhead_d() {
      let test = {
        clientId: this.clientId,
        deptId: this.deptId,
        seeDate: this.date,
        regFee: this.regFee,
        regLevelId: null,
        payWay: this.payWay,
        deptName:this.deptName
      };
      if (!test.clientId) {
        Dialog.confirm({
          message: "请选择联系人",
          confirmButtonText: "前往",
          confirmButtonColor: "#5B8DF6",
        })
          .then(() => {
            this.$router.push("/patient_card_selectuser_querydept");
          })
          .catch(() => {
            // on cancel
          });
        return;
      }
      if (this.date == "点击选择") {
        this.$toast.fail("未选择挂号日期");
        return;
      }
      if (this.showpoptime && this.showpoptime == "点击选择") {
        this.$toast.fail("未选择挂号时段");
        return;
      } else {
        test["select_poptime_start"] = this.popstarttime;
        test["select_poptime_end"] = this.popendtime;
      }
      // console.log(new Date(this.date+this.popendtime).etTime())
      if(new Date().getTime()>new Date(`${this.date} ${this.popendtime}:00`).getTime()-600000){
        this.$toast.fail("已过选择时间段，请重新选择")
        return
      }
      
      console.log(this.radio)
      if(this.radio=="wechat")
      {
        try {
        this.$showLoad("挂号确认中");
        let url = "/register/registerConfirm";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "post",
          test,
          (data) => {
            this.$hideLoad();
            // console.log(data);
            if(data.Regcode&&data.Regcode=="0")
            {
              Dialog.alert({
                  title: "挂号失败",
                  message:data.statusText
                }).then(() => {
                
                });
                return
            }
            if (data.data.needpay == true) {
              this.timeStamp = data.data.data.timeStamp;
              this.appId = data.data.data.appId;
              this.nonceStr = data.data.data.nonceStr;
              this.pacKage = data.data.data.package;
              this.signType = data.data.data.signType;
              this.paySign = data.data.data.paySign;
              this.out_trade_no=data.data.out_trade_no;
             
              if (typeof WeixinJSBridge == "undefined") {
                if (document.addEventListener) {
                  document.addEventListener(
                    "WeixinJSBridgeReady",
                    this.onBridgeReady(
                      this.appId,
                      this.timeStamp,
                      this.nonceStr,
                      this.pacKage,
                      this.signType,
                      this.paySign
                    ),
                    false
                  );
                } else if (document.attachEvent) {
                  document.attachEvent(
                    "WeixinJSBridgeReady",
                    this.onBridgeReady(
                      this.appId,
                      this.timeStamp,
                      this.nonceStr,
                      this.pacKage,
                      this.signType,
                      this.paySign
                    )
                  );
                  document.attachEvent(
                    "onWeixinJSBridgeReady",
                    this.onBridgeReady(
                      this.appId,
                      this.timeStamp,
                      this.nonceStr,
                      this.pacKage,
                      this.signType,
                      this.paySign
                    )
                  );
                }
              } else {
                this.onBridgeReady(
                  this.appId,
                  this.timeStamp,
                  this.nonceStr,
                  this.pacKage,
                  this.signType,
                  this.paySign
                );
              }
            } else {
              if (data.status == 200) {
                Dialog.alert({
                  title: "挂号成功",
                  message:
                    this.tips,
                }).then(() => {
                  this.$router.push({
                    path: "/reghistory_ymzyy",
                    query: {
                      clientId: this.clientId,
                      name: this.name,
                    },
                  });
                });
              } else {
                this.$toast.fail("挂号失败，请联系管理员退费");
              }
            }
          }
        );
      } catch (error) {
        this.isLoad = false;
        this.$hideLoad();
        this.$toast.fail("网络连接失败");
      }
      }
      else if(this.radio=="ybpay")
      {
      console.log(123123)
        test.name=this.name
        let reginfo=JSON.stringify(test)
        let data = {
        clientId:this.clientId,
        redirectUrl: `https://account.kmmds.top/healthcarepay?reginfo=${reginfo}`
      };
      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/outpatientfee/getpayAuthNo";
        await this.$axios_request.axios_request_body(
          "nodeserver", 
          url,
          "POST",
          data,
          res => {
            this.$hideLoad();
            if (res.status == 200 && res.data.url) {
              window.location.href = res.data.url;
            } else {
              this.$toast.fail("网络出错，稍后重试");
              return;
            }
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }

      }
      //请求医院信息
      // 医院的名字、地址、banner图片、图标、功能
    
    },
    //获取时间段
    async getTimes() {
      try {
        this.$showLoad();
        if (!this.$route.query.deptid) {
          this.localdeptid = this.$local.get("localdeptid");
        }
        let R_data = { deptId: this.localdeptid };
        let url = "/hospitalconf/getRegisterTime";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          R_data,
          (data) => {
            this.$hideLoad();
            this.poptimelist = data.data;
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
    //
    //获取参数
    getDetailsInfo() {
      this.getPayWay();
      if (this.path === "/querydept"||this.path === "/ylzyy_index"||this.path==="/ylzyy_scheduldetail"||this.path=="/ymz_index") {
        this.deptName = this.$route.query.dept_type.deptName;
        this.deptId = this.$route.query.dept_type.deptId;
        this.regFee = this.$route.query.regfre;
        if (this.$route.query.register_level == "N") {
          this.register_level_falg = false;
        } else if (this.$route.query.register_level == "Y") {
          this.register_level_falg = true;
        }
        this.setLocalDetailsInfo();
      } else if (this.path === "/patient_card_selectuser_querydept") {
        this.deptName = this.$local.get("deptName");
        this.deptId = this.$local.get("deptId");
        this.date = this.$local.get("date");
        this.register_level_falg = this.$local.get("register_level_falg");
        // this.regFee =this.$local.get("regFee");
        this.clientId = this.$route.query.clientId;
        this.name = this.$route.query.name;
        this.version = this.$local.get("version");
        this.regFee = this.$local.get("regFee");
        this.popstarttime = this.$local.get("popstarttime", this.popstarttime);
        this.popendtime = this.$local.get("popendtime", this.popendtime);
        this.showpoptime = this.$local.get("showpoptime", this.showpoptime);
      }
    },
    setLocalDetailsInfo() {
      let query = this.$route.query;
      if (query) {
        this.$local.set("register_level_falg", this.register_level_falg);
        this.$local.set("date", this.date);
        // this.$local.set("regFee");
        this.$local.set("deptName", this.deptName);
        this.$local.set("deptId", this.deptId);
        this.$local.set("version", this.version);
        this.$local.set("regFee", this.regFee);
        this.$local.set("showpoptime", this.showpoptime);
      }
    },
    //获取支付方式列表
    async getPayWay() {
      try {
        this.$showLoad();
        let url = "/hospitalconf/index/getPayType";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            this.payWay = data.data.objType[0].paykey;
            this.$hideLoad();
            this.paywaylist = data.data.objType;
            this.hospname = data.data.hosp_name;
            this.version = data.data.version;
            let type = data.data.version;
            if (type == "D") {
              this.vtypeflag = false;
            } else {
              this.vtypeflag = true;
            }
            //   console.log(this.vtypeflag)
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
     async getTips() {
      try {
        this.$showLoad();
        let url = "/hospitalconf/queryTips";
        await this.$axios_request.request_data(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            if(data.data){
this.tips=data?.data?.register
            }
         
         this.$hideLoad()
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
  },
};
</script>

<style lang="scss">
.main {
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f7f8fa;
  .body {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    .head {
      display: flex;
      width: 95%;
      margin: 0px auto;
      .datails_item_head {
        background-color: white;
        height: 50px;
        width: 85%;
        display: flex;
        justify-content: space-between;
        line-height: 50px;
      }
      .icon_btn {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        align-self: center;
        width: 18%;
        height: 50px;
        background-color: #5b8df6;
        .datails_item_head_text {
          color: white;
          font-size: 12px;
          font-size: 14px;
          line-height: 15px;
          height: 15px;
        }
      }
    }
    .poptime {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      .popbtn {
        width: 50%;
      }
    }
    .datails_item {
      background-color: white;
      width: 95%;
      margin: 0px auto;
      margin-top: 5px;
      height: 45px;
      display: flex;
      justify-content: space-between;
      line-height: 45px;
      padding: 0px 5px;
    }
    .datails_item_title {
      font-size: 16px;
      color: #747d8c;
    }
    .datails_item_text {
      font-size: 16px;
      color: #747d8c;
    }
    .pay_item {
      background-color: white;
      width: 94%;
      margin: 0px auto;
      height: 45px;
      display: flex;
      justify-content: space-between;
      line-height: 45px;
    }
    .datails_item_title {
      font-size: 16px;
      color: #747d8c;
    }
    .datails_item_text {
      font-size: 16px;
      color: #747d8c;
    }
  }

  .foot {
    width: 100%;
    position: fixed;
    bottom: 10vh;
    margin: 0px auto;
    .details_BTn {
      width: 95%;
      margin: 0px auto;
      letter-spacing: 10px;
    }
  }
}
.van-button--round {
  border-radius: 10px;
}
</style>